import * as Yup from "yup";

import {
    phoneRegex,
    zipRegex,
    cityRegEx,
    dateCantBeInFuture
} from "./validationFunctions";
import { stateRegEx } from "../validations_multilanguage/validationFunctions";



export const patientInfoValidations = (section, formType) => {

    if (section.active) {
        return Yup.object().shape({
        
            PFName: section.fields.PFName.validations.required.value && Yup.string().required(
                () =>
                    'Please provide a first name'
            ),
            PLName: section.fields.PLName.validations.required.value && Yup.string().required(
                () =>
                    'Please provide a last name'
            ),
            PPhone: formType.includes('Patient') && section.fields.PPhone.validations.required.value && Yup.string()
                .required(
                    () =>
                        'Please provide a phone number'
                )
                .matches(
                    phoneRegex,
                    'Please enter phone number in a valid format'
                ),
            Patient_Phone_Conform: formType.includes('Patient') && section.fields.PPhone.validations.required.value && Yup.string()
                .required(
                    () =>
                        "Please confirm your phone number"
                )
                .oneOf([formType.includes('Patient') && Yup.ref('PPhone'), '555'], 'Phone numbers must match'),

            PEmail: formType.includes('Patient') && section.fields.PEmail.validations.required.value && Yup.string()
                .required(
                    () =>
                        
                        'Please provide an email address'
                )
                .email(
                    'Please provide a valid email address'
                )
                .max(
                    section.fields.PEmail.validations.maxLength.value,
                    section.fields.PEmail.validations.maxLength.message
                ),
            Patient_Email_Conform: formType.includes('Patient') && section.fields.PEmail.validations.required.value && Yup.string()
                .required(
                    () =>
                        "Please confirm your email address"
                )
                // .oneOf([Yup.ref(`PEmail`), null], 'Email addresses must match'),
                .test(
                    'email-match',
                    'Email addresses must match',
                    function (value) {
                        const { PEmail } = this.parent; // Get the value of the PEmail field
                        if (!PEmail || !value) {
                            // If either field is empty, consider them a match
                            return true;
                        }
                        // Compare lowercase versions of the email addresses
                        return value.toLowerCase() === PEmail.toLowerCase();
                    }
                ),
            PAddress1: formType.includes('Patient') && section.fields.PAddress1.validations.required.value && Yup.string()
                .required(
                    () =>
                        'Please provide an address'
                )
                .max(
                    section.fields.PAddress1.validations.maxLength
                        .value,
                    section.fields.PAddress1.validations.maxLength
                        .message
                ),
            PAddress2: Yup.string()

                .max(
                    section.fields.PAddress2.validations.maxLength
                        .value,
                    section.fields.PAddress2.validations.maxLength
                        .message
                ),
            PCity: formType.includes('Patient') && section.fields.PCity.validations.required.value && Yup.string()
                .required(
                    () =>
                        'Please provide a city'
                )
                .matches(cityRegEx, 'City must contain only letters')
                .max(
                    section.fields.PCity.validations.maxLength.value,
                    section.fields.PCity.validations.maxLength.message
                ),
            PState: formType.includes('Patient') && section.fields.PState.validations.required.value && Yup.string()
                .required(
                    () =>
                        'Please provide a state'
                )
                .matches(stateRegEx, 'State must contain only letters')
                .max(
                    section.fields.PState.validations.maxLength.value,
                    section.fields.PState.validations.maxLength.message
                ),
            PMName: Yup.string()
                .max(
                    section.fields.PMName.validations.maxLength.value,
                    section.fields.PMName.validations.maxLength.message
                ),

            PDOB1: Yup.string()
                .required(
                    () =>
                        "DOB is required"
                )
                .max(
                    dateCantBeInFuture,
                    'future'
                )

                .test(
                    "PDOB",
                    "Please provide a more recent date",
                    function (date) {
                        var enteredDate = new Date(date);
                        return enteredDate.getFullYear() >= 1880;
                    }
                ).nullable()
                .test(
                    "PDOB",
                    'This date is in the future',
                    function (date) {
                        var todaysDate = new Date();
                        var enteredDate = new Date(date);
                        return todaysDate > enteredDate;
                    }
                )
                .test(
                    "PDOB",
                    'Please have an adult submit a proxy form on your behalf',
                    function (date) {
                        if (formType.includes('Patient')) {
                            var enteredDate = new Date(date);
                            var month = new Date().getMonth() + 1
                            var day = new Date().getDate()
                            var year = new Date().getFullYear() - 18
                            return new Date(`${month}/${day}/${year}`) > enteredDate;
                        }
                        else { return true }
                    }
                ),

            PZip: formType.includes('Patient') && section.fields.PZip.validations.required.value && Yup.string()
                .required(
                    () =>
                        'Please provide a zip code'
                )
                .matches(
                    zipRegex,
                    section.fields.PZip.validations.validZipcode.message
                )
        });
    }
};



